var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconRubricSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconRubric",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _path || (_path = _jsx("path", {
        d: "M1185.941 0c73.525 0 135.643 47.322 159.021 112.941h462.156V1920H113V112.941h462.155C598.535 47.322 660.652 0 734.176 0Zm56.47 1468.235H903.589v112.941h338.824v-112.94Zm-451.764-225.882H451.824v338.823h338.823v-338.823Zm677.647 0H903.588v112.941h564.706v-112.941ZM790.647 677.647H451.824v338.824h338.823V677.647Zm451.765 225.882H903.588v112.942h338.824V903.529Zm225.882-225.882H903.588v112.941h564.706v-112.94Zm-282.353-564.706H734.176c-31.058 0-56.47 25.299-56.47 56.47v169.413h564.706V169.412c0-31.172-25.412-56.47-56.47-56.47Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconRubricSolid.glyphName = 'rubric';
IconRubricSolid.variant = 'Solid';
IconRubricSolid.displayName = 'IconRubricSolid';
IconRubricSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconRubricSolid;
export { IconRubricSolid };